import { MessageBannerTheme, variants } from '../MessageBannerStyles.css';
import { baseTheme } from './MessageBannerBaseTheme.css';
import { multiVariantStyles } from './MessageBannerVariants.css';

/*******************
 * Component Theme
 *******************/

const MessageBannerStableTheme: MessageBannerTheme = {
  baseTheme,
  variants,
  multiVariantStyles
};

/*******************
 * Exports
 *******************/

export { MessageBannerStableTheme };
